// SPDX-License-Identifier: GPL-2.0-or-later
// Vetor 2D com as mesmas operações do `struct Vec` original (src/utility.h:315-340). Imutável.
export class Vec {
    x;
    y;
    constructor(x, y) {
        this.x = x;
        this.y = y;
    }
    add(o) {
        return new Vec(this.x + o.x, this.y + o.y);
    }
    sub(o) {
        return new Vec(this.x - o.x, this.y - o.y);
    }
    mul(factor) {
        return new Vec(this.x * factor, this.y * factor);
    }
    /** Como no original, dividir é multiplicar pelo inverso (`*this *= 1. / div`). */
    div(divisor) {
        return this.mul(1 / divisor);
    }
    mag() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    mag2() {
        return this.x * this.x + this.y * this.y;
    }
    equals(o) {
        return this.x === o.x && this.y === o.y;
    }
}
export function dot(a, b) {
    return a.x * b.x + a.y * b.y;
}
export function cross(a, b) {
    return a.x * b.y - a.y * b.x;
}
//# sourceMappingURL=vec.js.map